<template>
  <div class="service-ad" v-if="visible">
    <img :src="largeImage" class="service-ad__img hidden-mobile-down" />
    <img :src="mobileImage" class="service-ad__img hidden-mobile-up" />

    <div class="service-ad__close" @click="dismiss"></div>
    <div class="service-ad__goto" @click="goAndDismiss"></div>
  </div>
</template>

<script>
const STORAGE_KEY = "serviceAd_dismissed";

export default {
  name: "ServiceAd",
  props: {
    /** 唯一服務識別碼，新服務上線換一個新的 id 即可讓所有人重新看到 */
    serviceId: {
      type: String,
      required: true,
    },
    /** 廣告圖片路徑 */
    largeImage: {
      type: String,
      required: true,
    },
    mobileImage: {
      type: String,
      required: true,
    },
    /** 根據螢幕大小選擇要顯示的圖片 */
    /** 點擊下方區塊要前往的外部網址（與 productCode 二擇一） */
    href: {
      type: String,
      default: "",
    },
    /** 站內商品 Code，傳入後會透過 productListMap 導向商品頁（與 href 二擇一） */
    productCode: {
      type: String,
      default: "",
    },
    /** Whether the user is logged in */
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
    /** Whether the ad should be hidden (e.g. user already purchased, or on excluded route) */
    shouldHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    shouldHide(val) {
      if (val) this.visible = false;
    },
  },
  created() {
    const raw = localStorage.getItem(STORAGE_KEY);
    let dismissed = {};
    try {
      dismissed = raw ? JSON.parse(raw) : {};
    } catch {
      dismissed = {};
    }
    if (!this.isLoggedIn || this.shouldHide) {
      this.visible = false;
      return;
    }
    // 只要當前 serviceId 沒被標記過就顯示
    this.visible = !dismissed[this.serviceId];
  },
  methods: {
    markDismissed() {
      if (process.env.NODE_ENV !== "production") return;
      const raw = localStorage.getItem(STORAGE_KEY);
      let dismissed = {};
      try {
        dismissed = raw ? JSON.parse(raw) : {};
      } catch {
        dismissed = {};
      }
      dismissed[this.serviceId] = true;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissed));
    },
    dismiss() {
      this.markDismissed();
      this.visible = false;
      this.$emit("close");
    },
    goAndDismiss() {
      this.markDismissed();
      this.visible = false;
      this.$emit("close");
      if (this.productCode) {
        const productId = this.$store.getters.productListMap[this.productCode];
        this.$router.push(`/store/detail/${productId}`);
      } else if (this.href) {
        window.open(this.href, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_mixin.scss";

.service-ad {
  position: fixed;
  right: 100px;
  bottom: 52px;
  width: 200px;
  height: 205px;
  z-index: 100;
  border-radius: 8px;
  overflow: hidden;

  @include mobile {
    right: 24px;
    bottom: 100px;
    width: 149px;
    height: 163px;
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;

    @include mobile {
      width: 25px;
      height: 25px;
    }
  }

  &__goto {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200px;
    height: 61px;
    cursor: pointer;

    @include mobile {
      width: 149px;
      height: 48px;
    }
  }
}
</style>
